<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="create-card-model-dialog"
      max-width="100%"
      :open.sync="openDialog"
      :form-ref.sync="cardModelFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Créer un modèle de carte</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-container>
          <card-model-form
            :card-model-form.sync="cardModelForm"
            :rules="rules"
            :cardTypesChoice="cardTypesChoice"
            :card-origins-choice="cardOriginsChoice"
          ></card-model-form>
        </v-container>
      </template>
      <template v-slot:[`dialog.actions.save`]>Créer</template>
    </base-dialog>
  </div>
</template>
<script>
import { toRefs, onMounted, computed } from "@vue/composition-api";
import { useCardModel } from "@/composables/card-model";
import CardModelForm from "@/components/CardModel/CardModelForm";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    CardModelForm,
    BaseDialog,
  },
  props: {
    partner: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { cardModels, cardModelData, createCardModel } = useCardModel();

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Cycle de vie */
    onMounted(() => {
      cardModelData.cardModelForm.cardOrigin =
        cardModelData.cardOriginsChoice[0].value;
      cardModelData.cardModelForm.cardType =
        cardModelData.cardTypesChoice[0].value;
    });

    /* Méthodes */
    const saveItem = async function () {
      await createCardModel(props.partner.id);
      openDialog.value = cardModelData.createCardModelDialog;
    };

    return {
      createCardModel,
      ...toRefs(cardModelData),
      cardModels,
      saveItem,
      openDialog,
    };
  },
};
</script>
